import { Box, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { EDUCATIONAL_PARAGRAPHS } from '../constants';

export const EducationalContent = () => (
  <Box>
    <Typography
      as="h1"
      bold
      color={colors.neutral[600]}
      style={{ fontSize: 28, margin: 0, marginBottom: 20, marginTop: 16 }}
    >
      Which Works Best for You: Contractors or Employees?
    </Typography>
    {EDUCATIONAL_PARAGRAPHS.map((text, index) => (
      <Typography
        key={text.slice(0, 24)}
        size="body_large"
        color={colors.neutral[600]}
        style={{ marginTop: index === 0 ? 0 : 16, lineHeight: 1.5 }}
      >
        {text}
      </Typography>
    ))}
  </Box>
);
